import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { useFeaturedTripsQuery } from '@/services/api/catalogApi';
import TripShortcutCard from './TripShortcutCard';

/**
 * The three routes the administrator has chosen to highlight — backfilled
 * with the busiest trips when fewer than three are explicitly featured, so the
 * section is never empty once the catalog has any bookings at all.
 */
export function FeaturedTripsSection() {
  const { t } = useTranslation();
  const { data: trips, isLoading, isError } = useFeaturedTripsQuery();

  if (isLoading || isError || !trips || trips.length === 0) {
    return null;
  }

  return (
    <Box component="section" sx={{ py: { xs: 6, md: 8 }, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Stack spacing={4}>
          <Typography variant="h2" component="h2">
            {t('home.featuredTrips.title')}
          </Typography>

          <Box
            sx={{
              display: 'grid',
              gap: 3,
              // Admin-configurable (3, 4 or 6 trips): auto-fit rather than a
              // fixed column count, so however many come back from the
              // backend lay out reasonably across every breakpoint instead of
              // leaving empty cells or overflowing a column count sized for
              // the old fixed three.
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            }}
          >
            {trips.map((trip) => (
              <TripShortcutCard key={trip.slug} trip={trip} />
            ))}
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}

export default FeaturedTripsSection;
